import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest, cmsApiRequest } from "../../Lib/Utils/ApiRequest";
import { getLocaleFromCookie } from "../../Lib/Utils/getLocaleFromCookie";
import { IApiResponse } from "../../Orchestrator/Types/Index";
import { ICmsDestinationResponse } from "../../Orchestrator/Types/Interface/ICmsDestination";

export async function getCmsDestinations(): Promise<
  IApiResponse<ICmsDestinationResponse>
> {
  const ENDPOINTS = await getEndpoints();
  const endpoint = ENDPOINTS.getDestinationsAPI;

  const params = new URLSearchParams({
    "populate": "image",
    locale: await getLocaleFromCookie()
  });

  let endpointWithParams = `${endpoint}?${params.toString()}`;
  return await cmsApiRequest<ICmsDestinationResponse>(endpointWithParams, "GET");
}
